var getProductClient = require('../../../js_functions/getProductClient');

function filterFieldByClient(fieldVisibilityLogic) {
  // If no field, assume invisible.
  var visibility = false;
  var client = getProductClient();

  // If field visibility is object...
  if (typeof fieldVisibilityLogic === 'object') {
    // Assume anything falsey is invisible.
    visibility = fieldVisibilityLogic[client];
  } else {
    // Assume boolean. Apply accordingly.
    visibility = fieldVisibilityLogic;
  }

  return visibility;
}

// Returns a list of all the fields the client should be able to see.
function getVisibleClientFields(fieldVisibility) {
  return Object
    .entries(fieldVisibility)
    .filter(function (entry) {
      return filterFieldByClient(entry[1]);
    })
    .map(function(entry) {
      return entry[0];
    });
}

module.exports = getVisibleClientFields;
